import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
import services from '../services';
import TextField from '@material-ui/core/TextField';
import $ from 'jquery';
import { Fields, validateProperty, validate, Card } from "../../Common";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import { search } from '../../Common';
import { factoryItemValidationSchemaObject } from '../../Data/Validation/factoryItemValidationSchema';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';
import { Category } from '@material-ui/icons';

const screenCode = 'FACTORYITEM'

export function FactoryItemsListing(props) {
    
    const [factoryItems, setfactoryItems] = useState([]);
    const [allFactoryItem, setAllFactoryItem] = useState([])
    const [pageSize, setPageSize] = useState(4)
    const [currentPage, setCurrentPage] = useState(1);
    const [groups, setGroups] = useState();
    const [searchForm, setSearchForm] = useState({
        groupID: 0,
        operationEntityID: 0,
       // itemCategoryID: 0
    });
    const [factories, setFactories] = useState();
    const contentRowNames = ["factoryItemName", "factoryItemDescription", "price"]
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [isTableHidden, setIsTableHidden] = useState(true);

    const schema = Joi.object(factoryItemValidationSchemaObject).options({ allowUnknown: true })



    useEffect(() => {
    trackPromise(
        getPermissions()
        )
    }, []);

    useEffect(() => {
        trackPromise(
            FactoryByGroupEntity()
            )
    }, [searchForm.groupID]);

    useEffect(() => {
        trackPromise(
            handleSearch()
            )
    }, [searchForm.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWFACTORYITEMLISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITFACTORYITEM');
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isAddEditEnabled: isAddEditEnabled !== undefined,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !==undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });
        
        setGroupDropDownData();
    }


    async function setGroupDropDownData() {
        const result = await services.getGroups()

        setGroups(result)
    }
  

    async function getAllFactoryItem(groupid, factoryId) {
        const data = await services.getAllByFilter(groupid, factoryId);

        return data;
    }

    function destroyDataTable() {
        setIsTableHidden(true);
        $('#example').DataTable().destroy();
    }

    function createDataTable() {
        $('#example').DataTable();
        setIsTableHidden(false);
    }


    function handleClick(item) {
       
        props.history.push({
            pathname: 'factoryitems/addEdit',
            data: item,
            edit: true
        })
    }

    function handlePageChange(page) {
        setCurrentPage(page)
    }

    function handleGroupChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, factoryItemValidationSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
           
        });
        trackPromise(
        FactoryByGroupEntity(value))

        setErrors(error)
    }

    async function FactoryByGroupEntity() {
        let filteredData = await services.getOperationalEntityByGroupEntityID(searchForm.groupID);

        setFactories(filteredData)
        
    }

    function handleOperationEntityChange(e) {

        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, factoryItemValidationSchemaObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value,
        })
        setErrors(error);
    }



    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
            }
        }
        return items
    }


    function clearButton() {
       
        setSearchForm({
            ...searchForm,
            groupID: 0,
            operationEntityID: 0,
        });
    }

    async function handleSearch(e) {
        if(e !== undefined){
            const errorMessages = validate(schema, searchForm);
            errorMessages !== null ? setErrors(errorMessages) : setErrors({});
            if (errorMessages) return;
        }

        if(searchForm.groupID !== 0 && searchForm.operationEntityID !==0 ){
            destroyDataTable();
            var factoryItems = await getAllFactoryItem(searchForm.groupID, searchForm.operationEntityID);
            setAllFactoryItem(factoryItems);
            createDataTable();
        }
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title="Factory Items"
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Factory Items"
                            path="factoryitems/addEdit" />

                        <div className="card-body">

                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>

                                <div className="form-group row">

                                    <div className="col-md pb-1">

                                        <InputLabel shrink id="groupID">Group *</InputLabel>

                                        <Select
                                        fullWidth
                                        id="groupID"
                                        name="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        value={searchForm.groupID}
                                        onChange={(e) => handleGroupChange(e)}>
                                        <MenuItem value="0">--Select Group Name--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                        </Select>

                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select fullWidth
                                        id="operationEntityID"
                                        name="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        value={searchForm.operationEntityID}
                                        onChange={(e) => handleOperationEntityChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(factories)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}

                                </div>

                                </div>

                            </form>
                            <div className="table-responsive row-top-gap">
                            <table id="example" hidden={isTableHidden} className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Factory Item</th>
                                        <th>Description</th>
                                        <th> Item Category Type </th>
                                        
                                        { permissionList.isAddEditEnabled ? <th>Actions</th> : null }
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={allFactoryItem}
                                        contentRowNames={contentRowNames}
                                        hasEdit={permissionList.isAddEditEnabled}
                                        handleClick={handleClick} 
                                    />
                                </tbody>
                            </table>
                           
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )

}